import React from "react";

import {
  useDataGrid,
  DataGrid,
  GridColumns,
  EditButton,
  DeleteButton,
  List,
  Stack,
  esES,
} from "@pankod/refine-mui";
import { ICatalog } from "interfaces";

export const CatalogList: React.FC = () => {
  const { dataGridProps } = useDataGrid<ICatalog>({
    metaData: {
      populate: ["client"],
    },
  });

  const columns = React.useMemo<GridColumns<ICatalog>>(
    () => [
      {
        field: "client",
        headerName: "Cliente",
        flex: 1,
        valueGetter: (params) => params.row.client.name,
      },
      { field: "sku", headerName: "Sku", flex: 1 },
      { field: "price", headerName: "Precio", flex: 1 },
      { field: "description", headerName: "Descripción", flex: 1 },
      {
        headerName: "Acciones",
        headerAlign: "center",
        field: "actions",
        minWidth: 180,
        align: "center",
        flex: 1,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton size="small" hideText recordItemId={params.row.id} />
              <DeleteButton
                size="small"
                hideText
                recordItemId={params.row.id}
              />
            </Stack>
          );
        },
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        autoHeight
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
      />
    </List>
  );
};
